import clsx from 'clsx';

import { Icon } from '@gitbook/spine-icons';
import { Button } from '@gitbook/spine-react';

export function CommentThreadNav(props: { onPress: () => void; className?: string }) {
    const { onPress, className } = props;

    return (
        <div className={clsx('flex items-center gap-2 ', className)}>
            <Button
                onPress={onPress}
                className="w-fit"
                kind="blank"
                leadingIcon={Icon.ChevronLeft}
                label="Back"
                size="small"
                iconOnly
            />
            <span className="pt-0.5 text-ui-standout">Thread</span>
        </div>
    );
}
